import { UI, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import React, { useCallback } from 'react';
import { ScrollView } from 'react-native';

import { SignedInRootStackParamList } from '../../routes/types';

import { DirectTreasuryRedemption } from './products/DirectTreasuryRedemption';
import { FixedIncomeRedemption } from './products/FixedIncomeRedemption';
import { FundsRedemption } from './products/FundsRedemption';

export const RedemptionSolicitation: React.FC = () => {
  const { params } = useRoute<RouteProp<SignedInRootStackParamList, 'RedemptionSolicitation'>>();
  const navigation = useNavigation();

  const responsiveWidth = useBreakpointValue({
    base: 1,
    sm: 1,
    md: 0.42,
  });

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  const renderCorrectRedemptionProduct = () => {
    switch (params.productType) {
      case 'Funds':
        return <FundsRedemption onClose={goBack} />;

      case 'FixedIncome':
        return <FixedIncomeRedemption onClose={goBack} />;

      case 'DirectTreasury':
        return <DirectTreasuryRedemption onClose={goBack} />;

      default:
        return null;
    }
  };

  return (
    <UI.SliderModal width={responsiveWidth} onDismiss={goBack}>
      <ScrollView>
        <VStack p={Spacing['inset.sm']}>{renderCorrectRedemptionProduct()}</VStack>
      </ScrollView>
    </UI.SliderModal>
  );
};
